import { Fragment, useEffect, useRef, useState } from "react";
import { Button, IconButton } from "@mui/material/";
import "./SeleccionVehiculo.css";
import Car from "../../Assets/SVG/AutoGris.svg";
import CarActive from "../../Assets/SVG/AutoVerde.svg";
import Bici from "../../Assets/SVG/BicicletaGris.svg";
import BiciActive from "../../Assets/SVG/BicicletaVerde.svg";
import Moto from "../../Assets/SVG/MotoGris.svg";
import MotoActive from "../../Assets/SVG/MotoVerde.svg";
import Monopatin from "../../Assets/SVG/MonopatinGris.svg";
import MonopatinActive from "../../Assets/SVG/MonopatinVerde.svg";
import BiciElectrica from "../../Assets/SVG/BiciElectricaGris.svg";
import BiciElectricaActive from "../../Assets/SVG/BiciElectricaVerde.svg";
import Otro from "../../Assets/SVG/OtroGris.svg";
import OtroActive from "../../Assets/SVG/OtroVerde.svg";
import Devices from "../../Assets/SVG/divices.svg";
import DevicesActive from "../../Assets/SVG/divicesActive.svg";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Swal from "sweetalert2";

const SeleccionVehiculo = ({
  tipoSelected,
  handleChange,
  isWowUser,
  visibleProducts,
  scrollContainer,
}) => {
  const vehicleOptions = [
    { id: "auto", label: "Automóvil", icon: Car, activeIcon: CarActive },
    { id: "moto", label: "Motocicleta", icon: Moto, activeIcon: MotoActive },
    { id: "bike", label: "Bicicleta", icon: Bici, activeIcon: BiciActive },
    {
      id: "scooter",
      label: "Monopatín",
      icon: Monopatin,
      activeIcon: MonopatinActive,
    },
    {
      id: "eBike",
      label: "Bicicleta eléctrica",
      icon: BiciElectrica,
      activeIcon: BiciElectricaActive,
    },
    {
      id: "devices",
      label: "Dispositivos",
      icon: Devices,
      activeIcon: DevicesActive,
      enabled: true,
    },
    {
      id: "otro",
      label: "Otro",
      icon: Otro,
      activeIcon: OtroActive,
      enabled: true,
      info: "Vehículos considerados como 'Otro': triciclos eléctricos, trimotos, cuatrimotos, ATVS, Racers.",
    },
  ];

  const openInfo = (infoText) => {
    Swal.fire({
      icon: "info",
      text: infoText,
    });
  };

  const selectedOption = ["smartphone", "tablet", "laptop"].includes(
    tipoSelected
  )
    ? "devices"
    : tipoSelected;

  return (
    <Fragment>
      <div className="container-title">
        <div className="title-select">
          <p>¿Qué deseas asegurar?</p>
        </div>
      </div>
      <div className="container">
        <div className="container-seleccion" ref={scrollContainer}>
          {vehicleOptions
            .filter(
              (option) =>
                visibleProducts.includes(option.id) && option.enabled !== false
            )
            .map((option) => (
              <div className="icono" key={option.id}>
                <Button onClick={() => handleChange(option.id)} id={option.id}>
                  <img
                    src={
                      selectedOption === option.id
                        ? option.activeIcon
                        : option.icon
                    }
                    alt="Clupp"
                  />
                </Button>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <p>{option.label}</p>
                  {option.info && (
                    <IconButton
                      onClick={() => openInfo(option.info)}
                      sx={{
                        width: "20px",
                        height: "20px",
                        padding: "0",
                        margin: "0 0 10px 5px",
                      }}
                    >
                      <QuestionMarkIcon fontSize="small" />
                    </IconButton>
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>
    </Fragment>
  );
};

export default SeleccionVehiculo;
